import * as React from "react";
import {
  ActivityFragment,
  MadMinimalFragment,
  ReportFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { timeAgoLabel } from "../../../utils/timeAgo";
import { MadIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type ReportFilledActivity = ActivityFragment & {
  recipient: MadMinimalFragment;
  trackable: ReportFragment;
};

export function isReportFilledActivity(
  q: ActivityFragment
): q is ReportFilledActivity {
  return q.key === "report.filled";
}

interface ReportFilledActivityProps {
  activity: ReportFilledActivity;
}

export const ReportFilledActivity: React.FC<ReportFilledActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();
  return (
    <Activity
      activity={activity}
      id="reportFilledActivity"
      visual={<MadIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.reportFilled", {
          report: (
            <Link
              to={`/reports/${activity.trackable.id}`}
              key={activity.id}
            >
              {t("activity.objects.report")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
